/*eslint no-undef: "error"*/
import { useRef } from 'react';

const useDebounce = () => {
  const timeOutRef = useRef<any>(null);
  return (func: () => void, time: number) => {
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
    }
    timeOutRef.current = setTimeout(func, time);
  };
};
export default useDebounce;
